import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  ListItemButton,
  Stack,
  Typography
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { BILightGrey } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_EMP_JOBS_2, FETCH_CLIENT_SAR2 } from "../../constant/Apipath";
import ClientSARAddModal from "./ClientSARAddModal";
import ClientSARViewListingModal from "./ClientSARViewListingModal";
import ClientSARViewModal from "./ClientSARViewModal";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { useLocation } from "react-router-dom";
import moment from "moment";

export default function ClientSAR() {
  const [isLoading, setLoading] = useState(false);
  const [addModel, setAddModel] = useState(false);
  const [addModelData, setAddModelData] = useState({});
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const [listingLoading, setListingLoading] = useState(false);

  const [sortedData, setSortedData] = useState([]);
  const [jobData, setJobData] = useState({});
  const [listViewModal, setListViewModal] = useState(false);
  const location = useLocation();

  const LANGUAGE = ClientEnglishFallback.ClientSAR(multiLanguageData?.ClientSAR || {});
  const { TEXT_NO_REPORT, TEXT_SEE_MORE, TEXT_NO_DATA } = LANGUAGE;

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    setLoading(true);
    setListingLoading(true);

    try {
      const jobsData = await fetchInitialJobs();
      if (!jobsData?.length) {
        setSortedData([]);
        return;
      }

      const jobsWithSarData = await fetchSarDataForJobs(jobsData);

      // Keep the original order from API (same as native app)
      setSortedData(jobsWithSarData);
    } catch (error) {
      console.error("fetchJobs-> Error Fetching Jobs Data: ", error);
      setSortedData([]);
    } finally {
      setLoading(false);
      setListingLoading(false);
    }
  };

  const fetchInitialJobs = async () => {
    const requestObj = {
      PageNr: 1,
      NrOfRecPerPage: 100,
      FullSearch: location?.state?.searchText || "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SearchList: [
        {
          clientEmployeeId: selectedClientData?.ClientEmployeeId,
          ClientId: selectedClientData?.ClientId,
        }
      ]
    };

    const response = await Postrequestcall(
      FETCH_CLIENT_EMP_JOBS_2,
      requestObj,
      loginData?.accessToken
    );

    if (response?.status !== 200) {
      throw new Error(`Failed to fetch jobs: ${response?.status}`);
    }

    return response?.data?.data || [];
  };

  const fetchSarDataForJobs = async (jobsData) => {
    const sarPromises = jobsData?.map((job) => fetchSarDataForJob(job)) || [];
    const sarResults = await Promise.allSettled(sarPromises);

    return jobsData
      ?.map((job, index) => {
        const sarResult = sarResults[index];

        if (sarResult.status === "fulfilled" && sarResult.value) {
          return {
            ...job,
            sarData: sarResult.value.data || [],
            noOfRecords: sarResult.value.nrOfRecords || 0
          };
        }

        return {
          ...job,
          sarData: [],
          noOfRecords: 0
        };
      })
      .filter((job) => job.clientJobId);
  };

  const fetchSarDataForJob = async (job) => {
    if (!job?.jobCode) {
      return null;
    }

    const sarRequestObj = {
      PageNr: 1,
      NrOfRecPerPage: 3,
      FullSearch: "",
      UserId: loginData?.userInformation?.UserId,
      IncludeRecordNr: true,
      FetchAllowedRecordsOnly: true,
      SortList: [{ FieldName: "Date", Direction: "DESC" }],
      SearchList: [
        {
          clientEmployeeJobId: job.id
        }
      ]
    };

    try {
      const response = await Postrequestcall(
        FETCH_CLIENT_SAR2,
        sarRequestObj,
        loginData?.accessToken
      );

      if (response?.status === 200) {
        return response.data;
      }

      return null;
    } catch (error) {
      console.error(`fetchSarDataForJob-> Error fetching SAR data for job ${job.jobCode}: `, error);
      return null;
    }
  };

  const sortJobsByLatestSarDate = (jobs) => {
    return jobs?.sort((a, b) => {
      // Extract job codes
      const jobCodeA = a?.jobCode || "";
      const jobCodeB = b?.jobCode || "";

      // Extract numeric part from job codes (e.g., "JC113" -> 113, "122" -> 122)
      const numericA = parseInt(jobCodeA.replace(/\D/g, "")) || 0;
      const numericB = parseInt(jobCodeB.replace(/\D/g, "")) || 0;

      // Sort by numeric part in ascending order
      return numericA - numericB;
    });
  };

  const Listing = (props) => {
    const { data, listingLoader, reload, index } = props;
    const [viewModal, setViewModal] = useState(false);

    const [selectedSarData, setSelectedSarData] = useState(null);
    return (
      <>
        <Grid size={12} container spacing={1} key={index}>
          {listingLoader ? (
            <>
              <Stack sx={{ width: "100%", alignItems: "center" }}>
                <Loader />
              </Stack>
            </>
          ) : data?.sarData?.length !== 0 ? (
            <>
              {data?.sarData?.map((item, index) => {
                return (
                  <Grid
                    key={index}
                    size={12}
                    sx={{
                      padding: "0",
                      borderRadius: "10px",
                      border: "1px solid #e4e4e4"
                    }}>
                    <ListItemButton
                      onClick={() => {
                        setViewModal(true);
                        setSelectedSarData(item);
                      }}
                      sx={{
                        padding: "0",
                        borderRadius: "10px"
                      }}>
                      <Grid sx={{ padding: 1 }} size={12}>
                        <Stack
                          direction={"row"}
                          sx={{ display: "flex",  justifyContent: "space-between" }}
                          >
                          <Stack sx={{ gap: 1 }}  direction="row">
                            <Typography variant="body2">
                              {dayjs(item?.date).format("MMMM DD, YYYY")}
                            </Typography>
                            <Typography
                              sx={{
                                color: "grey"
                              }}
                              variant="body2">
                              {moment.utc(item?.time).local().format(" h:mm A")}
                            </Typography>
                          </Stack>
                        </Stack>
                      </Grid>
                    </ListItemButton>
                  </Grid>
                );
              })}
              {data?.noOfRecords > 3 && (
                <Button
                  onClick={() => {
                    setListViewModal(true);
                    setJobData(data);
                  }}
                  fullWidth
                  sx={{
                    backgroundColor: BILightGrey,
                    color: "black",
                    borderRadius: "10px",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: BILightGrey,
                    }
                  }}>
                  {TEXT_SEE_MORE} {data?.noOfRecords - 3}
                </Button>
              )}
            </>
          ) : (
            <>
              <Typography sx={{ width: "100%", textAlign: "center" }}>{TEXT_NO_REPORT}</Typography>
            </>
          )}
        </Grid>
        <ClientSARViewModal
          isOpen={viewModal}
          onClose={() => setViewModal(false)}
          data={data}
          sarData1={selectedSarData}
          reload={() => reload()}
        />
      </>
    );
  };

  return (
    <>
      <Grid size={12} container spacing={1}>
        {isLoading ? (
          <Stack sx={{ width: "100%", alignItems: "center" }}>
            <Loader fullScreen={true} />
          </Stack>
        ) : (
          <>
            {sortedData?.length === 0 ? (
              <Stack sx={{ width: "100%", height: "85vh", justifyContent: "center", alignItems: "center" }}>
                <Typography>{TEXT_NO_DATA}</Typography>
              </Stack>
            ) : (
              <>
                {sortedData?.map((item, index) => (
                  <Grid key={index} size={12}>
                    <Accordion defaultExpanded>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                          "& .MuiAccordionSummary-content": {
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            margin: "0 !important",
                            paddingRight: "16px",
                          },
                        }}>
                        <Stack direction={"row"} sx={{ alignItems: "center" }}>
                          <LocationOnIcon
                            sx={{
                              color: selectedClientData?.AccentColor,
                              mr: 1
                            }}
                          />
                          <Typography sx={{ padding: 0, margin: 0, fontSize: 16 }} variant="subtitle2">
                            {`${item?.jobCode} - ${item?.jobName}`}
                          </Typography>
                        </Stack>
                        <div
                          onClick={(e) => {
                            e?.stopPropagation();
                            setAddModel(true);
                            setAddModelData(item);
                          }}>
                          <AddIcon
                            sx={{
                              color: selectedClientData?.AccentColor
                            }}
                          />
                        </div>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Listing
                          data={item}
                          jobData={item}
                          listingLoader={listingLoading}
                          index={index}
                          key={index}
                          reload={() => fetchJobs()}
                        />
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                ))}
              </>
            )}
          </>
        )}
      </Grid>
      {addModel && (
        <ClientSARAddModal
          isOpen={addModel}
          onClose={() => setAddModel(false)}
          data={addModelData}
          reload={() => fetchJobs()}
        />
      )}
      <ClientSARViewListingModal
        data={jobData}
        open={listViewModal}
        onClose={() => setListViewModal(false)}
      />
    </>
  );
}

